// Pedir un archivo desde una pantalla, y que lo recoja el panel del Brain (3.1).
//
// **Por que hace falta un contexto.** El boton «Subir Documento» vive en
// Conocimiento y el panel vive en el armazon, que es la ruta padre. La pantalla
// no puede abrir el panel ni subir por su cuenta sin escribir una segunda
// subida, que es justo lo que R7 prohibe: la pantalla pide el archivo y el
// armazon hace lo mismo que ya hace al soltarlo encima.
//
// Es una sola funcion a proposito. Si algun dia hay que pasar mas cosas, se
// vera entonces.

import { createContext, useContext } from 'react'

export const GuidedUpload = createContext<{ askForFile: () => void }>({
  // Sin proveedor no se rompe nada: no hay panel que abrir, asi que no hay
  // nada que pedir. Pasa en las pruebas que pintan una pantalla suelta.
  askForFile: () => {},
})

/** Abrir el selector del sistema; lo que se elija lo recoge el panel. */
export function useGuidedUpload(): () => void {
  return useContext(GuidedUpload).askForFile
}
